export type FundingStatus = "ifc_required" | "funding_incomplete" | "complete";

// Highest-priority status in the session determines
// the overall session funding status.
export const determineSessionFundingStatus = (session = []): FundingStatus => {
	if (!Array.isArray(session) || session.length === 0) {
		return "funding_incomplete";
	}

	const statuses = session.map((event) => determineEventFundingStatus(event));

	if (statuses.includes("ifc_required")) {
		return "ifc_required";
	}

	if (statuses.includes("funding_incomplete")) {
		return "funding_incomplete";
	}

	return "complete";
};

export const determineEventFundingStatus = (event): FundingStatus => {
	const hasMedicare = Boolean(event?.patient?.medicare);

	const hasHealthFund = Boolean(
		event?.patient?.policies?.[0]?.healthFund?.id,
	);

	const ifcRequired = event?.ifc_required === true;

	const ifcSent = event?.ifc_sent === true;

	// Highest priority:
	// IFC is required but hasn't been sent.
	if (ifcRequired && !ifcSent) {
		return "ifc_required";
	}

	// Second priority:
	// Medicare / health fund details incomplete.
	if (!hasMedicare || !hasHealthFund) {
		return "funding_incomplete";
	}

	// All funding requirements satisfied.
	return "complete";
};
